var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-timeline',{attrs:{"mode":_vm.mode,"reverse":_vm.reverse},scopedSlots:_vm._u([(_vm.$scopedSlots.pending)?{key:"pending",fn:function(){return [_vm._t("pending")]},proxy:true}:null,(_vm.$scopedSlots.pendingDot)?{key:"pendingDot",fn:function(){return [_vm._t("pendingDot")]},proxy:true}:null],null,true)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }